// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".offline-payment-time-wrapper[data-v-86ea16a2]{align-items:center;background:#fff5cc;border-radius:9.99rem;display:flex;font-size:.12rem;justify-content:center;margin:.08rem auto .16rem;padding:.08rem .12rem;width:2.09rem}.offline-payment-time-wrapper .icon-time[data-v-86ea16a2]{height:.14rem;margin-right:.04rem;width:.14rem}.offline-payment-time-wrapper .text[data-v-86ea16a2]{color:#09af4c;font-weight:700;margin-left:.04rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
